import {
	useFormErrorNotification,
	useFormSuccessNotification,
} from "@babackapp/react-hook-forms-components/form-notifications";
import { useMutation } from "@tanstack/react-query";
import { $api } from "../generated/client";
import useInvalidateShop from "./use-invalidate-shop";

type ImageURL =
	| "/shops/{shopId}/preferences/portals/background"
	| "/shops/{shopId}/logo";

export default function useUploadImage(shopId: string, url: ImageURL) {
	const successNotification = useFormSuccessNotification();
	const errorNotification = useFormErrorNotification();
	const invalidateShop = useInvalidateShop(shopId);

	const mutation = $api.useMutation("post", url);

	return useMutation({
		onSuccess: () => {
			invalidateShop();
			successNotification();
		},
		onError: () => {
			errorNotification();
		},
		mutationFn: (file: File) => {
			const formData = new FormData();
			formData.append("file", file);
			return mutation.mutateAsync({
				params: { path: { shopId: shopId } },
				body: formData as any,
			});
		},
	});
}
